import { createShallowStore, createStoreWithSubscribe } from '@frontend/store';

interface MarketingAttributionDemoState {
  isDemoAccount: boolean;
  isDemoDataReady: boolean;

  setIsDemoAccount: (isDemoAccount: boolean) => void;
  setIsDemoDataReady: (isDemoDataReady: boolean) => void;
}

const useMarketingAttributionDemoStore = createStoreWithSubscribe<MarketingAttributionDemoState>(
  (set) => ({
    isDemoAccount: false,
    isDemoDataReady: false,

    setIsDemoAccount: (isDemoAccount) => {
      set({ isDemoAccount });
    },
    setIsDemoDataReady: (isDemoDataReady) => {
      set({ isDemoDataReady });
    },
  }),
  {
    name: 'MarketingAttributionDemoStore',
    trace: true,
  }
);

export const useMarketingAttributionDemoShallowStore = createShallowStore<MarketingAttributionDemoState>(
  useMarketingAttributionDemoStore
);
